import FullscreenContainer from "features/containers/FullscreenContainer";
import Spinner from "features/spinner/Spinner";

const LoadingPage: React.FC = () => {
  return (
    <FullscreenContainer sx={{ display: "grid", placeItems: "center" }}>
      <Spinner size="3rem" />
    </FullscreenContainer>
  );
}

export default LoadingPage;
